import { Routes, Route } from 'react-router';
import React, {Component} from 'react';
import Iframe from 'react-iframe';
import axios from 'axios';
import * as QuicksightEmbedding from 'amazon-quicksight-embedding-sdk';
const embeddingContext = await QuicksightEmbedding.createEmbeddingContext();

const Home = () => (
  <div className='home'>
  <center>
    <div id="dashboardContainer"></div>
    <GetEmbedUrl page="hope_goals"/>
  </center>
  </div>
);


const About = () => (
  <div className='about'>
    <h1>About Me</h1>
    <p>Ipsum dolor dolorem consectetur est velit fugiat. Dolorem provident corporis fuga saepe distinctio ipsam? Et quos harum excepturi dolorum molestias?</p>
    <p>Ipsum dolor dolorem consectetur est velit fugiat. Dolorem provident corporis fuga saepe distinctio ipsam? Et quos harum excepturi dolorum molestias?</p>
  </div>
);

const Contact = () => (
  <div className='contact'>
    <h1>Contact Me</h1>
    <p>You can reach me via email: <strong>hello@example.com</strong></p>
  </div>
);

class RecalledProductsPage extends Component{

  render(){
    return (
      <div className='recalled-products'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="recalled-products"/>
        </center>
      </div>
    );
  }
}

class SupplyChainPage extends Component{

  render(){
    return (
      <div className='supplychain'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="supplychain"/>
        </center>
      </div>
    );
  }
}

class DiseaseStatePage extends Component{

  render(){
    return (
      <div className='disease-state'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="disease-state"/>
        </center>
      </div>
    );
  }
}

class MarketingDashboardPage extends Component{

  render(){
    return (
      <div className='marketing-dashboard'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="marketing-dashboard"/>
        </center>
      </div>
    );
  }
}

class IQVIAtargetListPage extends Component{

  render(){
    return (
      <div className='target-list'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="target-list"/>
        </center>
      </div>
    );
  }
}

class ProductDataPage extends Component{

  render(){
    return (
      <div className='product-data'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="product-data"/>
        </center>
      </div>
    );
  }
}

class DCOrderPage extends Component{

  render(){
    return (
      <div className='dc-orders'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="dc-order"/>
        </center>
      </div>
    );
  }
}

class LastStockedShippedPage extends Component{

  render(){
    return (
      <div className='last-stocked-shipped'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="last-stocked-shipped"/>
        </center>
      </div>
    );
  }
}

class OptumToolDashboard extends Component{

  render(){
    return (
      <div className='optum-tool'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="optum-tool"/>
        </center>
      </div>
    );
  }
}

class OrderingToolPage extends Component{

  render(){
    return (
      <div className='orderingtool'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="ordering_tools"/>
        </center>
      </div>
    );
  }
}

class DonorReportPage extends Component{

  render(){
    return (
      <div className='donorreport'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="donor_report"/>
        </center>
      </div>
    );
  }
}

class PamsDashboardPage extends Component{

  render(){
    return (
      <div className='pamsdashboard'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="pams_dashboard"/>
        </center>
      </div>
    );
  }
}

class ScottsDashboardPage extends Component{

  render(){
    return (
      <div className='supply-chain-dashboard'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="scotts_dashboard"/>
        </center>
      </div>
    );
  }
}

class DohDashboardPage extends Component{

  render(){
    return (
      <div className='dohdashboard'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="doh_dashboard"/>
        </center>
      </div>
    );
  }
}

class NEOverviewDashboardPage extends Component{

  render(){
    return (
      <div className='/ne-overview-dashboard'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="ne_overview_dashboard"/>
        </center>
      </div>
    );
  }
}

class AmDashboardPage extends Component{

  render(){
    return (
      <div className='/am-dashboard'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="am_dashboard"/>
        </center>
      </div>
    );
  }
}

class ColdChainProductDashboard extends Component{

  render(){
    return (
      <div className='/cold-chain-product'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="cold_chain_product"/>
        </center>
      </div>
    );
  }
}

class PrascoReportDashboard extends Component{

  render(){
    return (
      <div className='/prasco-report'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="prasco_report"/>
        </center>
      </div>
    );
  }
}


class ItDashboardPage extends Component{

  render(){
    return (
      <div className='/it-analytics'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="it_analytics"/>
        </center>
      </div>
    );
  }
}

class ReceivingDistP1Page extends Component{

  render(){
    return (
      <div className='/receiving-distributing-p1'>
        <center>
          <div id="dashboardContainer"></div>
          <GetEmbedUrl page="receiving_dist_p1"/>
        </center>
      </div>
    );
  }
}



class ShippingManifestPage extends Component{

  constructor(props) {
    super(props);

    this.state = {
        startDate: "",
        endDate: ""
    }

    this.handleClick = this.handleClick.bind(this);
    this.handlePrintClick = this.handlePrintClick.bind(this);
  }

  userFormValue = (event) => {
      this.setState({ [event.target.name]: event.target.value });
  }

  handleClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");
    const data =  {first_date:this.startDate.value,last_date:this.endDate.value,companyId:e[0]};
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-b3-orders-dropdown`;
    document.getElementById('endbreak').insertAdjacentHTML('afterend','<p id="click-load">Loading...</p>');
    const res = axios.post(url,data)
    .then((response)=>{
      var responseDiv = document.getElementById('order');
      if(responseDiv != undefined){
        responseDiv.parentNode.removeChild(responseDiv);
      }
      var clickLoad = document.getElementById('click-load');
      if(clickLoad != undefined){
        clickLoad.remove();
      }
      console.log(response);
      var div = document.getElementById('print-button');

      div.insertAdjacentHTML('beforebegin', response.data);

    });
  }

  handlePrintClick = () => {
    const data =  {orderId:document.getElementById('order').value};
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/print-manifest`;
    document.getElementById('endbreak').insertAdjacentHTML('afterend','<p id="click-load">Loading...</p>');
    const res = axios.post(url,data)
    .then((response)=>{
        console.log(response);
        var clickLoad = document.getElementById('click-load');
        if(clickLoad != undefined){
          clickLoad.remove();
        }
        var mywindow = window.open('', 'PRINT', 'height=1000,width=1400');

        mywindow.document.write('<html>');
        mywindow.document.write('<body>');
        mywindow.document.write(response.data);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;

    });
  }

  componentDidMount() {
    fetch("https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-sites-shipping-manifest")
      .then(res => {
        return res.text();
      })
      .then(
        (result) => {
          console.log(result)
          var load = document.getElementById('nonbreak');
          load.insertAdjacentHTML('afterend','<br id="newbreak"></br>');
          load.insertAdjacentHTML('afterend',result);
          if(document.getElementById('loading-sites')){
            document.getElementById('loading-sites').remove();
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render(){
    return(
    <div class="shipping-manifest">
        <p id='loading-sites'>Loading sites...</p>
        <label for="order" id="orderLabelprint" style={{margin:'3px',fontSize:'24px',color:'#be1f41'}}>Print Order Shipping Manifest</label><br id="nonbreak"></br>
        <label for="order" id="orderLabel" style={{margin:'3px',fontSize:'16px'}}>Start Date</label>
        <input type="date" value={this.state.startDate} onChange={this.userFormValue} ref={(ref) => {this.startDate = ref}} style={{width: '15.75%', color: '#be1f41', height: '3rem',margin: '10px',minWidth:'140px', paddingLeft: '3px',paddingRight: '3px'}} id="start_date" name='startDate'></input>
        <label for="order" id="orderLabel" style={{margin:'3px',fontSize:'16px'}}>End Date</label>
        <input type="date" value={this.state.endDate} onChange={this.userFormValue} ref={(ref) => {this.endDate = ref}} style={{width: '15.75%', color: '#be1f41', height: '3rem',margin: '10px',minWidth:'140px', paddingLeft: '3px',paddingRight: '3px'}} id="end_date" name="endDate" ></input>
        <input type="submit" name="refresh-date" id="refresh-button" value="REFRESH" style={{width: '13%',height: '3rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.handleClick}></input>

        <select name="order" ref={(ref) => {this.orderId = ref}} id="order" style={{width: '45%', color: '#be1f41', height: '3rem',margin: '10px',minWidth:'140px', paddingLeft: '3px',paddingRight: '3px'}}><option value="empty">--</option></select>
        <input type="submit" name="print-report" id="print-button" value="PRINT" style={{width: '13%',height: '3rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.handlePrintClick}></input><br id="endbreak"></br>
    </div>
  );
  }
}

class ProductCreationPage extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    const data =  {data:this.ndc.value};
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/finale-create-product`;

    const res = axios.post(url,data)
    .then((response)=>{
      var responseDiv = document.getElementById('response');
      if(responseDiv != undefined){
        responseDiv.parentNode.removeChild(responseDiv);
      }
      console.log(response);
      var div = document.getElementById('product-creation-div');

      div.insertAdjacentHTML('beforebegin', response.data);

    });
  }

  render() {
    return (
      <div>
      <center>
      <div id="product-creation-div">
          <textarea ref={(ref) => {this.ndc = ref}} placeholder="NDC..."/>
          <br/>
        <strong>
          <button onClick={this.handleClick}>SUBMIT</button>
        </strong>
      </div>

      <p> <strong>*Only the necessary supply chain managers should input new products</strong></p>
      </center>

      </div>
    );
  }
}


class YearlyDonorReceiptCsvPage extends Component {

  constructor(props) {
   super(props);

   this.state = {
       Year: ""
   }

   this.handleClickPrint = this.handleClickPrint.bind(this);
   this.handleDonorClick = this.handleDonorClick.bind(this);
   this.handleClickPrintcsv = this.handleClickPrintcsv.bind(this);
 }

 userFormValue = (event) => {
     this.setState({ [event.target.name]: event.target.value });
 }



 handleClickPrint = () => {
   const data =  {data:document.getElementById('receipt-select').value};
   console.log(data);
   const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/sandbox/print-donor-receipt`;

   document.getElementById('receipt-button').insertAdjacentHTML('afterend','<p id="print-loading">Loading...</p>');

   const res = axios.post(url,data)
   .then((response)=>{
     var mywindow = window.open('', 'PRINT', 'height=1000,width=1400');
     if(document.getElementById('print-loading')){
       document.getElementById('print-loading').remove();
     }
     mywindow.document.write('<html>');
     mywindow.document.write('<body>');
     mywindow.document.write(response.data);
     mywindow.document.write('</body></html>');

     mywindow.document.close(); // necessary for IE >= 10
     mywindow.focus(); // necessary for IE >= 10*/



   });
 }

 handleClickPrintcsv = () => {
   const data =  {
     data:document.getElementById('donor-select').value,
     Year:document.getElementById('Year').value,
   };

   const donor_year = document.getElementById('Year').value;

   const url = `https://t5h7rabp8j.execute-api.us-east-1.amazonaws.com/Sandbox/Year-Donor-Receipt`;

   document.getElementById('receipt-button')
     ?.insertAdjacentHTML('afterend', '<p id="print-loading">Loading...</p>');

   axios.post(url, data, { responseType: "text" })
     .then((response) => {
       document.getElementById('print-loading')?.remove();
       const csvText = response.data;

       const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
       const downloadUrl = window.URL.createObjectURL(blob);

       const a = document.createElement("a");
       a.href = downloadUrl;
       a.download = `donor_receipt_${donor_year}.csv`;

       document.body.appendChild(a);
       a.click();
       a.remove();

       window.URL.revokeObjectURL(downloadUrl);
     })
     .catch((err) => {
       document.getElementById('print-loading')?.remove();
       console.error("CSV download failed:", err);
     });
 };

 handleDonorClick = () => {
   const data =  {
     data:document.getElementById('donor-select').value,
     Year:document.getElementById('Year').value,
 };
   console.log(data);
   const url = `https://t5h7rabp8j.execute-api.us-east-1.amazonaws.com/Sandbox/Year-Donor-Receipt`;

   const res = axios.post(url,data)
   .then((response)=>{
     console.log(response.data);

   });
 }


 componentDidMount() {
     const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/sandbox/get-donors`;
     const data = {};
     const res = axios.post(url,data)
     .then((response)=>{
       console.log(response.data);
       var donor = document.getElementById('donor-begin');
       if(donor){
         donor.insertAdjacentHTML('beforebegin',response.data);
         donor.remove();
       }else if(document.getElementById('donor-button') && !donor){
         var donorSelect = document.getElementById('donor-button');
         donorSelect.insertAdjacentHTML('beforebegin',response.data);

       }
       if(document.getElementById('loading')){
         document.getElementById('loading').remove();
       }

     });
   }



 render() {


   return (
     <div>
     <center>
     <div id="donor-receipt-div" >
         <select id='donor-begin' style={{width:'45%',color:'#be1f41',height:'3rem',margin:'10px',minWidth:'140px',padding: '0 3px 0 3px'}}><option id="">--</option></select><br/>
         <label for="order" id="orderLabel" style={{margin:'3px',fontSize:'16px'}}>Year</label>
         <input type="number" value={this.state.Year} onChange={this.userFormValue} style={{width: '17.25%', color: '#be1f41', height: '3rem',margin: '10px',minWidth:'140px', padding:'0 3px 0 3px'}} id="Year" name="Year" min="1900" max="2050"/>
         <p id='loading'>Loading...</p>
         <strong>
           <button id='donor-button' style={{width:'13%',height:'3rem',backgroundColor:'#be1f41',margin:'10px',padding:'0 30px 0 30px',fontWeight:'bold',fontSize:'15px',minWidth:'70px',border:'none',color:'white'}} onClick={this.handleClickPrintcsv}>Print CSV</button>
         </strong>
         <br/>
     </div>
     </center>
     </div>
   );
 }
}

const DSCSA_SEARCH_FIELDS = [
  { value: "serial", label: "Serial Number", placeholder: "Enter serial number..." },
  { value: "po", label: "Order / PO Number", placeholder: "Enter PO / order number..." },
  { value: "gtin", label: "GTIN-14", placeholder: "Enter 14-digit GTIN..." },
  { value: "lotnumber", label: "Lot Number", placeholder: "Enter lot number (partial matches allowed)..." },
  { value: "expdate", label: "Expiration Date", placeholder: "YYYY-MM-DD" },
];

class SearchByPOPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      field: "serial",
      loading: false,
      searched: false,
    };
  }

  userFormValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSearch = () => {
    const value = (this.state.value || "").trim();
    const field = this.state.field || "serial";

    if (!value) {
      alert("Please enter a value to search for.");
      return;
    }

    this.setState({ loading: true, searched: false });

    const url =
      "https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/Search-By-Serial";

    axios
      .post(url, { field, value, limit: 1000 })
      .then((response) => {
        const csvString = response.data;

        const blob = new Blob([csvString], { type: "text/csv" });
        const blobUrl = window.URL.createObjectURL(blob);

        const safeValue = value.replace(/[^A-Za-z0-9._-]+/g, "_").slice(0, 60);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `dscsa_${field}_${safeValue}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(blobUrl);

        this.setState({ loading: false, searched: true });
      })
      .catch((err) => {
        console.error("Full error:", err.response);
        this.setState({ loading: false });
        alert("Search failed.");
      });
  };

  render() {
    const { loading, searched, field } = this.state;
    const activeField =
      DSCSA_SEARCH_FIELDS.find((f) => f.value === field) || DSCSA_SEARCH_FIELDS[0];

    return (
      <center>
        <div
          id="searchbypo-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            marginTop: "60px",
          }}
        >
          <label
            style={{
              margin: "3px",
              fontSize: "26px",
              color: "#be1f41",
              fontWeight: "bold",
            }}
          >
            Search By Serial
          </label>
          <p style={{ margin: "4px", color: "#666" }}>
            Search by serial number, order/PO, GTIN, lot, or expiration date.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
              marginTop: "25px",
            }}
          >
            <select
              id="searchbypo-field"
              name="field"
              value={field}
              onChange={this.userFormValue}
              style={{
                height: "3rem",
                color: "#be1f41",
                padding: "0 10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontWeight: "bold",
                backgroundColor: "white",
              }}
            >
              {DSCSA_SEARCH_FIELDS.map((f) => (
                <option key={f.value} value={f.value}>
                  {f.label}
                </option>
              ))}
            </select>

            <input
              id="searchbypo-value"
              name="value"
              value={this.state.value}
              onChange={this.userFormValue}
              placeholder={activeField.placeholder}
              style={{
                width: "500px",
                color: "#be1f41",
                height: "3rem",
                padding: "0 10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />

            <input
              type="submit"
              id="searchbypo-button"
              value={loading ? "Searching..." : "SEARCH"}
              disabled={loading}
              style={{
                height: "3rem",
                backgroundColor: "#be1f41",
                border: "none",
                color: "white",
                fontSize: "15px",
                fontWeight: "bold",
                padding: "0 30px",
                borderRadius: "4px",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.6 : 1,
              }}
              onClick={this.handleSearch}
            />
          </div>

          {loading && <p style={{ marginTop: "20px" }}>Loading...</p>}

          {searched && (
            <p style={{ color: "green", marginTop: "20px" }}>
              ✓ Download started.
            </p>
          )}
        </div>
      </center>
    );
  }
}

class DonorReceiptPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
        startDate: "",
        endDate: ""
    }

    this.handleClickPrint = this.handleClickPrint.bind(this);
    this.handleDonorClick = this.handleDonorClick.bind(this);
  }

  userFormValue = (event) => {
      this.setState({ [event.target.name]: event.target.value });
  }



  handleClickPrint = () => {
    const data =  {data:document.getElementById('receipt-select').value};
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/sandbox/print-donor-receipt`;

    document.getElementById('receipt-button').insertAdjacentHTML('afterend','<p id="print-loading">Loading...</p>');

    const res = axios.post(url,data)
    .then((response)=>{
      var mywindow = window.open('', 'PRINT', 'height=1000,width=1400');
      if(document.getElementById('print-loading')){
        document.getElementById('print-loading').remove();
      }
      mywindow.document.write('<html>');
      mywindow.document.write('<body>');
      mywindow.document.write(response.data);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/



    });
  }

  handleDonorClick = () => {
    const data =  {
      data:document.getElementById('donor-select').value,
      start_date:document.getElementById('start_date').value,
      end_date:document.getElementById('end_date').value
  };
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/sandbox/get-donor-receipts`;
    var receipts = document.getElementById('receipts-begin');
    if(!document.getElementById('loading-receipts')){
      if(receipts){
        receipts.insertAdjacentHTML("afterend",'<p id="loading-receipts">Loading...</p>');
      }else if(document.getElementById('receipts-select')){
        document.getElementById('receipts-select').insertAdjacentHTML('afterend','<p id="loading-receipts">Loading...</p>');
      }
    }

    const res = axios.post(url,data)
    .then((response)=>{
      console.log(response.data);
      var receipts = document.getElementById('receipts-begin');
      if(receipts){
        receipts.insertAdjacentHTML('beforebegin',response.data);
        receipts.remove();
      }else if(document.getElementById('receipt-button') && !receipts){
        var receiptsSelect = document.getElementById('receipt-button');
        if(document.getElementById('receipt-select')){
          document.getElementById('receipt-select').remove();
        }
        receiptsSelect.insertAdjacentHTML('beforebegin',response.data);

      }

      if(document.getElementById('loading-receipts')){
        document.getElementById('loading-receipts').remove();
      }


    });
  }


  componentDidMount() {
      const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/sandbox/get-donors`;
      const data = {};
      const res = axios.post(url,data)
      .then((response)=>{
        console.log(response.data);
        var donor = document.getElementById('donor-begin');
        if(donor){
          donor.insertAdjacentHTML('beforebegin',response.data);
          donor.remove();
        }else if(document.getElementById('donor-button') && !donor){
          var donorSelect = document.getElementById('donor-button');
          donorSelect.insertAdjacentHTML('beforebegin',response.data);

        }
        if(document.getElementById('loading')){
          document.getElementById('loading').remove();
        }

      });
    }



  render() {


    return (
      <div>
      <center>
      <div id="donor-receipt-div" >
          <select id='donor-begin' style={{width:'45%',color:'#be1f41',height:'3rem',margin:'10px',minWidth:'140px',padding: '0 3px 0 3px'}}><option id="">--</option></select><br/>
          <label for="order" id="orderLabel" style={{margin:'3px',fontSize:'16px'}}>Start Date</label>
          <input type="date" value={this.state.startDate} onChange={this.userFormValue} style={{width: '17.25%', color: '#be1f41', height: '3rem',margin: '10px',minWidth:'140px', padding:'0 3px 0 3px'}} id="start_date" name="startDate"/>
          <label for="order" id="orderLabel" style={{margin:'3px',fontSize:'16px'}}>End Date</label>
          <input type="date" value={this.state.endDate} onChange={this.userFormValue} style={{width: '17.25%', color: '#be1f41', height: '3rem',margin: '10px',minWidth:'140px', padding:'0 3px 0 3px'}} id="end_date" name="endDate" />
          <p id='loading'>Loading...</p>
          <strong>
            <button id='donor-button' style={{width:'13%',height:'3rem',backgroundColor:'#be1f41',margin:'10px',padding:'0 30px 0 30px',fontWeight:'bold',fontSize:'15px',minWidth:'70px',border:'none',color:'white'}} onClick={this.handleDonorClick}>GET RECEIPTS</button>
          </strong>
          <br/>
          <select id='receipts-begin' style={{width:'45%',color:'#be1f41',height:'3rem',margin:'10px',minWidth:'140px',padding: '0 3px 0 3px'}}><option id="">--</option></select>
        <strong>
          <button id='receipt-button' style={{width:'13%',height:'3rem',backgroundColor:'#be1f41',margin:'10px',padding:'0 30px 0 30px',fontWeight:'bold',fontSize:'15px',minWidth:'70px',border:'none',color:'white'}} onClick={this.handleClickPrint}>PRINT</button>
        </strong>
      </div>
      </center>
      </div>
    );
  }
}



class NetworkExpansionPage extends Component{

  render(){
    return (
      <div className='networkexpansion'>
      <center>
        <div id="dashboardContainer"></div>
        <GetEmbedUrl page="ne_dashboard"/>
      </center>
      </div>
    );
  }
}

class WeightedScoresPage extends Component{

  render(){
    return (
      <div className='weighted-scores'>
      <center>
        <div id="dashboardContainer"></div>
        <GetEmbedUrl page="weighted_scores"/>
      </center>
      </div>
    );
  }
}

class InformationTechPage extends Component{

  render(){
    return (
      <div className='infotech'>
      <center>
      </center>
      </div>
    );
  }
}

class TherapeuticsPage extends Component{

  render(){
    return (
      <div className='therapeutics'>
      <center>
      </center>
      </div>
    );
  }
}

class DistributionPage extends Component{

  render(){
    return (
      <center>
      <div className='distribution'>
      </div>
      </center>
    );
  }
}

class AccountManagementPage extends Component{

  render(){
    return (
      <center>
      <div className='accountmanagement'>
      </div>
      </center>
    );
  }
}

class FundManagementPage extends Component{

  render(){
    return (
      <center>
      <div className='fundmanagement'>
      </div>
      </center>
    );
  }
}

class LeadershipPage extends Component{

  render(){
    return (
      <center>
      <div className='leadership'>
      </div>
      </center>
    );
  }
}

class MarketingPage extends Component{

  render(){
    return (
      <center>
      <div className='marketing'>
      </div>
      </center>
    );
  }
}

class InsulinTrackerPage extends Component{

  render(){
    return (
      <center>
      <div className='insulin-tracker'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="insulintracker"/>
      </div>
      </center>
    );
  }
}

class SupplyChainTargetedReportPage extends Component{

  render(){
    return (
      <center>
      <div className='targeted-report'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="targeted-report"/>
      </div>
      </center>
    );
  }
}

class TargetListAvailabilityPage extends Component{

  render(){
    return (
      <center>
      <div className='target-list-availability'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="target-list-availability"/>
      </div>
      </center>
    );
  }
}

class UsageDashboardPage extends Component{

  render(){
    return (
      <center>
      <div className='usage-tracking'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="usage_tracking"/>
      </div>
      </center>
    );
  }
}

class IrregularOrdersPage extends Component{

  render(){
    return (
      <center>
      <div className='irregular-orders'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="irregular_orders"/>
      </div>
      </center>
    );
  }
}



class EhopeReportPage extends Component{

  render(){
    return (
      <center>
      <div className='ehope-reports'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="ehope_reports"/>
      </div>
      </center>
    );
  }
}

class ITrequestPage extends Component{
  render(){
    const url  = "https://dispensaryofhope.formstack.com/forms/js.php/support_request";
    const url2 = "http://www.formstack.com?utm_source=jsembed&utm_medium=product&utm_campaign=product+branding&fa=h,4538770";
    return (

      <center>
      <div className='it-request'>

        <iframe src="https://dispensaryofhope.formstack.com/forms/support_request" title="Support Request" width="1000px" height="1000px"></iframe>
      </div>
      </center>
    );
  }
}

class QuarterlyNumbersPage extends Component{

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.viewClick = this.viewClick.bind(this);
    this.refreshClick = this.refreshClick.bind(this);
  }

  viewClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    const data =  {
      siteId:e[2],
      companyId:e[0],
      companyName:name,
      quarter:document.getElementById('old-quarter-input').value,
      year:document.getElementById('old-year-input').value
    };
    console.log(data);
    document.getElementById("orderLabelprint").insertAdjacentHTML('beforebegin','<p id="load">Loading quarterly numbers...</p>');
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/qn-submission-check`;
    const res = axios.post(url,data)
    .then((response)=>{
      var sites = document.getElementById('view-button');
      var load = document.getElementById('load');
      var table1 = document.getElementById('first-table');
      var table2 = document.getElementById('second-table');
      var styling1 = document.getElementById('table-styling-1');
      var styling2 = document.getElementById('table-styling-2');
      if(table1){
        table1.remove();
        table2.remove();
        styling1.remove();
        styling2.remove();
      }
      sites.insertAdjacentHTML('afterend',response.data);
      load.remove();
    });
  }

  refreshClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    const data =  {
      siteId:e[2],
      companyId:e[0],
      companyName:name,
      Quarter:document.getElementById('old-quarter-input').value,
      Year:document.getElementById('old-year-input').value,
    };
    console.log(data);
    document.getElementById("orderLabelprint").insertAdjacentHTML('beforebegin','<p id="load">Getting quarterly numbers...</p>');
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/refresh-qn`;
    const res = axios.post(url,data)
    .then((response)=>{
      console.log(response);
      document.getElementById('old-fills-input').value = response.data.fills;
      document.getElementById('old-encounters-input').value = response.data.encounters;
      document.getElementById('old-patients-input').value = response.data.patients;
      var load = document.getElementById('load');
      load.remove();

    });
  }


  handleClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");
    console.log(document.getElementById('qn-select').value);
    if(document.getElementById('qn-select').value === 'update'){
      var action = 'Update';
    }else if(document.getElementById('qn-select').value === 'New'){
      var action = 'Insert';
    }else{
      window.location.reload(false);
      alert('Please choose from action dropdown!');
    }

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    const data =  {
      action: action,
      updateQuarter:document.getElementById('quarter-input').value,
      updateYear:document.getElementById('year-input').value,
      updateFills:document.getElementById('fills-input').value,
      updateEncounters:document.getElementById('encounters-input').value,
      updatePatients:document.getElementById('patients-input').value,
      siteId:e[2],
      companyId:e[0],
      site:name,
      quarter:document.getElementById('old-quarter-input').value,
      year:document.getElementById('old-year-input').value,
      fills:document.getElementById('old-fills-input').value,
      encounters:document.getElementById('old-encounters-input').value,
      patients:document.getElementById('old-patients-input').value
    };
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/quarterly-numbers`;
    const res = axios.post(url,data)
    .then((response)=>{
      alert('Thank you for your submission!')

    });
  }

  componentDidMount() {
    fetch("https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-sites-shipping-manifest")
      .then(res => {
        return res.text();
      })
      .then(
        (result) => {
          console.log(result)
          var load = document.getElementById('nonbreak');
          load.insertAdjacentHTML('afterend','<br id="newbreak"></br>');
          load.insertAdjacentHTML('afterend',result);
          if(document.getElementById('loading-sites')){
            document.getElementById('loading-sites').remove();
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render(){
    return(
    <div class="quarterly-numbers">
        <p id='loading-sites'>Loading sites...</p>
        <center>
        <label for="order" id="orderLabelprint" style={{margin:'3px',fontSize:'24px',color:'#be1f41'}}>Quarterly Numbers</label><br id="nonbreak"></br>
        <select name="qn-select" id="qn-select" style={{width: '35%',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'600px',backgroundColor:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'3px',paddingRight:'3px'}}>
          <option value="null">--</option>
          <option value="update">Update</option>
          <option value="New">New Input</option>
        </select><br></br>
        <p style={{width:'100%', color:'#be1f41',fontWeight:'bold',fontSize:'18px',}}> If you choose update, populate the fields on the left with the correct quarter and put the new information in the fields on the right. </p><br></br>
        <p style={{width:'100%', color:'#be1f41',fontWeight:'bold',fontSize:'18px',}}> If you choose new input, fill in the fields on the left with the information. </p><br></br>
        <label for="quarter-input" id="quarterLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Quarter</label>
        <input type="number" name="quarter" id="old-quarter-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="quarter-input" id="quarterLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Updated Quarter</label>
        <input type="number" name="quarter" id="quarter-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <label for="year-input" id="yearLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Year</label>
        <input type="number" name="year" id="old-year-input"   style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="year-input" id="yearLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Updated Year</label>
        <input type="number" name="year" id="year-input"   style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <label for="fills-input" id="fillsLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Fills</label>
        <input type="number"  name="fills" id="old-fills-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="fills-input" id="fillsLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Updated Fills</label>
        <input type="number" name="fills" id="fills-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <label for="patients-input" id="patientsLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Unique Patients</label>
        <input type="number" name="unique-patients" id="old-patients-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="patients-input" id="patientsLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Updated Unique Patients</label>
        <input type="number" name="unique-patients" id="patients-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <label for="encounters-input" id="encountersLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Encounters</label>
        <input type="number" name="encounters" id="old-encounters-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="encounters-input" id="encountersLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'15%'}}>Updated Encounters</label>
        <input type="number" name="encounters" id="encounters-input"  style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <input type="submit" name="refresh-qn" id="refresh-button" value="POPULATE" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.refreshClick}></input>
        <input type="submit" name="submit-qn" id="submit-button" value="SUBMIT" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.handleClick}></input>
        <input type="submit" name="view-qn" id="view-button" value="VIEW REPORTS" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.viewClick}></input><br></br>
        </center>
    </div>
  );
  }
}



class ViewInsulinReconciliationPage extends Component{

  constructor(props) {
    super(props);

    this.viewClick = this.viewClick.bind(this);
    this.printClick = this.printClick.bind(this);
    this.downloadClick = this.downloadClick.bind(this);
    this.downloadEliLillyClick = this.downloadEliLillyClick.bind(this);
  }

  downloadClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");
    const data =  {
      siteId:e[2],
      companyId:e[0],
      quarter:document.getElementById('qir-view-quarter-input').value,
      year:document.getElementById('qir-view-year-input').value
    };
    console.log(data);
    var siteSelect = document.getElementById('qir-label');
    siteSelect.insertAdjacentHTML('beforebegin','<p id="load">Loading csv...</p>');
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-qir-csv-data`;
    const res = axios.post(url,data)
    .then((response)=>{
      var load = document.getElementById('load');
      load.remove();
      var downloadButton = document.getElementById('qir-eli-lilly-download-button');
      var csvButton = document.getElementById('csv');
      console.log(csvButton);
      if(csvButton === null){
        downloadButton.insertAdjacentHTML('afterend','<br></br><a id="csv" style="color: white;background-color: #be1f41;height: 1rem;padding: 10px;font-weight: bold;" href="' + response.data + '"> DOWNLOAD CSV HERE</a>');

      }else{
        csvButton.remove();
        downloadButton.insertAdjacentHTML('afterend','<br></br><a id="csv" style="color: white;background-color: #be1f41;height: 1rem;padding: 10px;font-weight: bold;" href="' + response.data + '"> DOWNLOAD CSV HERE</a>');
      }
      console.log(response);
/*<a style="width: 10%;color: white;background-color: #be1f41;height: 1rem;padding: 10px;font-weight: bold;" href="https://qir-csv.s3.amazonaws.com/qir.csv?AWSAccessKeyId=ASIAUA6JDV6SUY4YS2EG&amp;Signature=HnmKp%2BWZw8tUJPRqaJmAuL3ThB8%3D&amp;x-amz-security-token=IQoJb3JpZ2luX2VjEGgaCXVzLWVhc3QtMSJHMEUCIFlhLlN5uKIKxtcTKdxyEAFkyFeI0pxD7qLplpceQsU5AiEAreCsdu%2BLFA6jm5wvJ24S7SbD2%2B%2FWbNbFcJ6Gw30uz0EqngIIMBADGgwyNzY5MTAyODg4MDUiDOOeI56b5HfNTNQgqSr7AbuuxTWbp6Rkzstu9w5ZuJWmJsRry%2ByXa9FMYLL8XiPwnU8d8oFYwqjVVMtw2NPzoCtVwJ0tCT9ZZKo0sPaOcti6ku9sgXyHUrJwumKgTCEica%2FoktkpJ3Gtf7U%2BELgMdvbjFkhEUkJSf0ac0Jqp0%2B4E10PmrrAk7ZPCSVXx5O8bEBkLliMNlXhUJB0Gwfx6g6yvpBelZ1eyJ0PwFKObdRQ98kOZ8tDJw44SUtIjRlGD6qxjViisTClbiryy21m24N9GtRDF1aKpEd6G%2FdY%2BU9CR%2FyOjh0eFJ%2FsALo80J4J4aZ%2BDYq2ffNCO46XsRdtk%2BhefXeqHp7b9AksTMPLp7owGOpoBPyEhQR8Z4LihxzXJvZ5EAYFgLg0b4kTIiON5tVJWN%2BEErP7G6NuCjsAsf5nFP5kWonmK3ibdNfBGkaKKT5yxfJhQnMKjWK9LuGn7L6H6ubs8adroClcM%2FpabfjJw6HHcsXbv4%2B9FiY4DpUfpkhT3BTBQ4ICfJHmCeAhq9v4ayizhBvYAKXqaxKDqzIKERXvUhBaPwnbMz9u%2BDw%3D%3D&amp;Expires=1637597957"> DOWNLOAD CSV HERE</a>*/
    });
  }

  downloadEliLillyClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");
    const data =  {
      siteId:e[2],
      companyId:e[0],
      quarter:document.getElementById('qir-view-quarter-input').value,
      year:document.getElementById('qir-view-year-input').value
    };
    console.log(data);
    var siteSelect = document.getElementById('qir-label');
    siteSelect.insertAdjacentHTML('beforebegin','<p id="load">Loading csv...</p>');
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-eli-lilly-csv`;
    const res = axios.post(url,data)
    .then((response)=>{
      var load = document.getElementById('load');
      load.remove();
      var downloadButton = document.getElementById('qir-eli-lilly-download-button');
      var csvButton = document.getElementById('eli-lilly-csv');
      console.log(csvButton);
      if(csvButton === null){
        downloadButton.insertAdjacentHTML('afterend','<br></br><a id="eli-lilly-csv" style="color: white;background-color: #be1f41;height: 1rem;padding: 10px;font-weight: bold;" href="' + response.data + '"> DOWNLOAD Eli Lilly Report</a>');

      }else{
        csvButton.remove();
        downloadButton.insertAdjacentHTML('afterend','<br></br><a id="eli-lilly-csv" style="color: white;background-color: #be1f41;height: 1rem;padding: 10px;font-weight: bold;" href="' + response.data + '"> DOWNLOAD Eli Lilly Report</a>');
      }
      console.log(response);
/*<a style="width: 10%;color: white;background-color: #be1f41;height: 1rem;padding: 10px;font-weight: bold;" href="https://qir-csv.s3.amazonaws.com/qir.csv?AWSAccessKeyId=ASIAUA6JDV6SUY4YS2EG&amp;Signature=HnmKp%2BWZw8tUJPRqaJmAuL3ThB8%3D&amp;x-amz-security-token=IQoJb3JpZ2luX2VjEGgaCXVzLWVhc3QtMSJHMEUCIFlhLlN5uKIKxtcTKdxyEAFkyFeI0pxD7qLplpceQsU5AiEAreCsdu%2BLFA6jm5wvJ24S7SbD2%2B%2FWbNbFcJ6Gw30uz0EqngIIMBADGgwyNzY5MTAyODg4MDUiDOOeI56b5HfNTNQgqSr7AbuuxTWbp6Rkzstu9w5ZuJWmJsRry%2ByXa9FMYLL8XiPwnU8d8oFYwqjVVMtw2NPzoCtVwJ0tCT9ZZKo0sPaOcti6ku9sgXyHUrJwumKgTCEica%2FoktkpJ3Gtf7U%2BELgMdvbjFkhEUkJSf0ac0Jqp0%2B4E10PmrrAk7ZPCSVXx5O8bEBkLliMNlXhUJB0Gwfx6g6yvpBelZ1eyJ0PwFKObdRQ98kOZ8tDJw44SUtIjRlGD6qxjViisTClbiryy21m24N9GtRDF1aKpEd6G%2FdY%2BU9CR%2FyOjh0eFJ%2FsALo80J4J4aZ%2BDYq2ffNCO46XsRdtk%2BhefXeqHp7b9AksTMPLp7owGOpoBPyEhQR8Z4LihxzXJvZ5EAYFgLg0b4kTIiON5tVJWN%2BEErP7G6NuCjsAsf5nFP5kWonmK3ibdNfBGkaKKT5yxfJhQnMKjWK9LuGn7L6H6ubs8adroClcM%2FpabfjJw6HHcsXbv4%2B9FiY4DpUfpkhT3BTBQ4ICfJHmCeAhq9v4ayizhBvYAKXqaxKDqzIKERXvUhBaPwnbMz9u%2BDw%3D%3D&amp;Expires=1637597957"> DOWNLOAD CSV HERE</a>*/
    });
  }

  viewClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    const data =  {
      siteId:e[2],
      companyId:e[0],
      companyName:name,
      quarter:document.getElementById('qir-view-quarter-input').value,
      year:document.getElementById('qir-view-year-input').value
    };
    console.log(data);
    var siteSelect = document.getElementById('site-select');
    siteSelect.insertAdjacentHTML('beforebegin','<p id="load">Loading...</p>');
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-qir-data`;
    const res = axios.post(url,data)
    .then((response)=>{
      var button = document.getElementById('qir-eli-lilly-download-button');
      var load = document.getElementById('load');
      button.insertAdjacentHTML('afterend',response.data);
      load.remove();

    });
  }

  printClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    const data =  {
      siteId:e[2],
      companyId:e[0],
      companyName:name,
      quarter:document.getElementById('qir-view-quarter-input').value,
      year:document.getElementById('qir-view-year-input').value
    };
    console.log(data);
    var siteSelect = document.getElementById('site-select');
    siteSelect.insertAdjacentHTML('beforebegin','<p id="load">Loading...</p>');
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-qir-data`;
    const res = axios.post(url,data)
    .then((response)=>{
      var load = document.getElementById('load');
      load.remove();
      var mywindow = window.open('', 'PRINT', 'height=1000,width=1400');

      mywindow.document.write('<html>');
      mywindow.document.write('<body>');
      mywindow.document.write(response.data);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

    });

  }

  componentDidMount() {
    fetch("https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-sites-shipping-manifest")
      .then(res => {
        return res.text();
      })
      .then(
        (result) => {
          console.log(result)
          var load = document.getElementById('nonbreak');
          load.insertAdjacentHTML('afterend','<br id="newbreak"></br>');
          load.insertAdjacentHTML('afterend',result);
          if(document.getElementById('loading-sites')){
            document.getElementById('loading-sites').remove();
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render(){
    return(
    <div class="view-insulin-reconciliation">
        <p id='loading-sites'>Loading sites...</p>
        <center>
        <label for="qir-label" id="qir-label" style={{margin:'3px',fontSize:'24px',color:'#be1f41',width:'400px'}}>Quarterly Insulin Reconciliation</label><br id="nonbreak"></br>
        <label for="qir-view-quarter-input" id="qir-view-quarterLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'60px'}}>Quarter</label>
        <select name="qir-view-quarter" id="qir-view-quarter-input"  style={{width: '35%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}>
          <option>--</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="All">All Quarters</option>
        </select>
        <br></br>
        <label for="qir-view-year-input" id="qir-view-yearLabel"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'60px'}}>Year</label>
        <input type="number" name="qir-view-year" id="qir-view-year-input"  min="2000" max="3000" style={{width: '8%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>
        <input type="submit" name="view-qir" id="qir-view-button" value="VIEW" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.viewClick}></input>
        <input type="submit" value="PRINT" id="qir-print-button" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.printClick}/>
        <input type="submit" value="DOWNLOAD" id="qir-download-button" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.downloadClick}/>
        <input type="submit" value="DOWNLOAD Eli Lilly" id="qir-eli-lilly-download-button" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.downloadEliLillyClick}/>

          </center>
    </div>
  );
  }
}

const inputStyle = {
  width: '200px',
  height: '2rem',
  color: '#be1f41',
  border: '1px solid #ccc',
  fontSize: '15px',
  padding: '0 8px',
  margin: '10px 5px',
  borderRadius: '4px',
};

const buttonStyle = {
  width: '120px',
  height: '2rem',
  backgroundColor: '#be1f41',
  border: 'none',
  color: 'white',
  fontSize: '15px',
  fontWeight: 'bold',
  borderRadius: '4px',
  cursor: 'pointer',
  margin: '10px 5px',
};

const cellStyle = {
  border: '1px solid #999',
  padding: '10px',
  textAlign: 'left',
};

class AllocationPage extends Component{
handleNdcSearchClick = () => {
  var e = document.getElementById('ndc-allocation').value;
  var search_button = document.getElementById('ndc-submit-button');
  search_button.insertAdjacentHTML('afterend','<p id="allocation-load">Loading...</p>');

  
  
  if(e.length !== 11){
    alert("The NDC you inputted is not in the correct NDC format. It needs to be 11 characters.");
  }else{
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/search-allocation-ndc`;
    const data = {"ndc":e};
    document.getElementById('ndc-submit-button').insertAdjacentHTML('afterend','<p hidden id="ndc-value">' + e + '</p>');
    const res = axios.post(url,data)
    .then((response)=>{
      console.log(response);
      document.getElementById('allocation-load').remove();
      if(response.status === 200){
        document.getElementById('ndc').textContent = response.data.ndc;
        document.getElementById('priority').textContent = response.data.priority;
        document.getElementById('product').textContent = response.data.name;
        document.getElementById('quantity').textContent = response.data.quantity;
      }else{
        alert("NDC not found.");
      }
    }).catch(function(e){
      console.log(e);
      alert("NDC not found or something went wrong. Contact IT team for further instructions.");
      //error handling logic
    });
  }
}



handleNdcUpdateClick = () => {
  var table = document.getElementById('allocation-table');
  table.insertAdjacentHTML('afterend','<p id="allocation-load">Loading...</p>');
  var ndc_amount = document.getElementById('ndc-amount').value;
  var ndc_value = document.getElementById('ndc').textContent;
  var ndc_password = document.getElementById('password-allocation').value;
  console.log(ndc_amount);
  console.log(ndc_value);
  console.log(ndc_password);

  const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/update-allocation-ndc`;
  const data = {"ndc":ndc_value,"amount":ndc_amount,"password":ndc_password};
  const res = axios.post(url,data)
  .then((response)=>{
    document.getElementById('allocation-load').remove();

    console.log(response);
    if(response.status === 200){
      if(response.data === "Password is incorrect."){
        alert("Password is incorrect. Please use correct password to update.");
      }else{
        alert("Successfully updated.");
      }
      
    }else{
      alert("Try again or contact IT Team.");
    }
  }).catch((e)=>{
    document.getElementById('allocation-load').remove();

    alert("Try again or contact IT Team.");
  });
  
}
render(){
  return (
    <center>
    <div class="allocation">
      <div>
        <input
          type="number"
          placeholder="NDC..."
          name="ndc-allocation"
          id="ndc-allocation"
          style={inputStyle}
        />
        <input type="submit" value="SEARCH" onClick={this.handleNdcSearchClick}/>
      </div>

      <div>
        <input
          type="text"
          placeholder="Password..."
          name="password-allocation"
          id="password-allocation"
          style={inputStyle}
        />
      </div>

      <table id="allocation-table">
        <thead>
          <tr>
            <th style={cellStyle}>Product</th>
            <th style={cellStyle}>NDC</th>
            <th style={cellStyle}>Priority</th>
            <th style={cellStyle}>Maximum Shipment Quantity</th>
            <th style={cellStyle}>New Quantity</th>
            <th style={cellStyle}>Submit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td id="product" style={cellStyle}></td>
            <td id="ndc" style={cellStyle}></td>
            <td id="priority" style={cellStyle}></td>
            <td id="quantity" style={cellStyle}></td>
            <td style={cellStyle}>
              <input
                type="number"
                placeholder="New quantity..."
                name="ndc-amount"
                id="ndc-amount"
                style={inputStyle}
              />
            </td>
            <td style={cellStyle}>
              <input type="submit" id='ndc-submit-button' value="SUBMIT" style={buttonStyle} onClick={this.handleNdcUpdateClick}/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </center>
  );
}

}
class AddressShortenerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rawAddress: '',
      shortenedAddress: '',
      verifiedAddress: '',
      loading: false,
      verified: false,
      error: '',
    };

    this.abbreviations = {
      street: 'St',
      avenue: 'Ave',
      road: 'Rd',
      boulevard: 'Blvd',
      drive: 'Dr',
      lane: 'Ln',
      court: 'Ct',
      place: 'Pl',
      square: 'Sq',
      circle: 'Cir',
      highway: 'Hwy',
      parkway: 'Pkwy',
      suite: 'Ste',
      room: 'Rm',
      attention: 'Attn',
    };
  }

  userFormValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  removeSpecialCharacters = (text) => {
    return text
      .replace(/[^\w\s,#.-]/g, '')   
      .replace(/\s+/g, ' ')
      .trim();
  };

  shortenAddressWords = (text) => {
    let cleaned = text;

    Object.keys(this.abbreviations).forEach((word) => {
      const regex = new RegExp(`\\b${word}\\b`, 'gi');
      cleaned = cleaned.replace(regex, this.abbreviations[word]);
    });

    return cleaned;
  };

  handleShorten = () => {
    const { rawAddress } = this.state;

    if (!rawAddress.trim()) {
      this.setState({ error: 'Please enter an address.' });
      return;
    }

    const noSpecials = this.removeSpecialCharacters(rawAddress);
    const shortened = this.shortenAddressWords(noSpecials);

    this.setState({
      shortenedAddress: shortened,
      verifiedAddress: '',
      verified: false,
      error: '',
    });
  };

  handleVerify = async () => {
    const { rawAddress } = this.state;

    if (!rawAddress.trim()) {
      this.setState({ error: 'Please enter an address.' });
      return;
    }

    const noSpecials = this.removeSpecialCharacters(rawAddress);
    const shortened = this.shortenAddressWords(noSpecials);

    this.setState({
      loading: true,
      error: '',
      shortenedAddress: shortened,
      verifiedAddress: '',
      verified: false,
    });

    try {
      const url = "https://t5h7rabp8j.execute-api.us-east-1.amazonaws.com/Sandbox/Google-Address-Validation";

      const response = await axios.post(url, {
        address: shortened,
      });

      this.setState({
        verifiedAddress: response.data.verifiedAddress || shortened,
        verified: true,
        loading: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
        verified: false,
        error: 'Address verification failed.',
      });
    }
  };

  render() {
    return (
      <center>
        <div
          className="address-shortener-page"
          style={{
            width: '100%',
            maxWidth: '900px',
            marginTop: '50px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <label
            style={{
              marginBottom: '20px',
              fontSize: '28px',
              color: '#be1f41',
              fontWeight: 'bold',
            }}
          >
            Address Shortener / Verifier
          </label>

          <textarea
            name="rawAddress"
            value={this.state.rawAddress}
            onChange={this.userFormValue}
            placeholder="Enter full address here..."
            style={{
              width: '700px',
              minHeight: '140px',
              padding: '12px',
              fontSize: '16px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              color: '#333',
            }}
          />

          <div
            style={{
              marginTop: '20px',
              display: 'flex',
              gap: '12px',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <button
              onClick={this.handleShorten}
              style={{
                height: '3rem',
                backgroundColor: '#be1f41',
                border: 'none',
                color: 'white',
                fontSize: '15px',
                fontWeight: 'bold',
                padding: '0 30px',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              SHORTEN
            </button>

            <button
              onClick={this.handleVerify}
              disabled={this.state.loading}
              style={{
                height: '3rem',
                backgroundColor: '#be1f41',
                border: 'none',
                color: 'white',
                fontSize: '15px',
                fontWeight: 'bold',
                padding: '0 30px',
                borderRadius: '4px',
                cursor: this.state.loading ? 'not-allowed' : 'pointer',
                opacity: this.state.loading ? 0.6 : 1,
              }}
            >
              {this.state.loading ? 'VERIFYING...' : 'VERIFY'}
            </button>
          </div>

          {this.state.error && (
            <p style={{ color: 'red', marginTop: '20px', fontWeight: 'bold' }}>
              {this.state.error}
            </p>
          )}

          {this.state.shortenedAddress && (
            <div
              style={{
                width: '700px',
                marginTop: '30px',
                textAlign: 'left',
                border: '1px solid #ddd',
                borderRadius: '6px',
                padding: '15px',
                backgroundColor: '#fafafa',
              }}
            >
              <p style={{ color: '#be1f41', fontWeight: 'bold', fontSize: '18px' }}>
                Shortened Address
              </p>
              <p>{this.state.shortenedAddress}</p>
            </div>
          )}

          {this.state.verifiedAddress && (
            <div
              style={{
                width: '700px',
                marginTop: '20px',
                textAlign: 'left',
                border: '1px solid #ddd',
                borderRadius: '6px',
                padding: '15px',
                backgroundColor: '#f4fff6',
              }}
            >
              <p style={{ color: 'green', fontWeight: 'bold', fontSize: '18px' }}>
                Verified Address
              </p>
              <p>{this.state.verifiedAddress}</p>
            </div>
          )}
        </div>
      </center>
    );
  }
}

class InsulinReconciliationUpdatePage extends Component{

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.refreshClick = this.refreshClick.bind(this);
    this.clearNDC = this.clearNDC.bind(this);
  }

  refreshClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    var quarter = document.getElementById('qir-update-quarter-input').value;
    var year = document.getElementById('qir-update-year-input').value;
    var drug = document.getElementById('qir-select').value;

    var ndc = ""
    if(drug === "Humulin7030"){
      ndc = "00002871501";
    }else if(drug === "HumulinN"){
      ndc = "00002831501";
    }else if(drug === "HumulinR"){
      ndc = "00002821501";
    }else if(drug === "Humalog"){
      ndc = "00002751001";
    }else if(drug === "HumalogPre"){
      ndc = "00002879959";
    }else if(drug === "Humalog7525"){
      ndc = "00002879759";
    }else if(drug === "Basaglar"){
      ndc = "00002771559";
    }else if(drug === "Trulicity75"){
      ndc = "00002143380";
    }else if(drug === "Trulicity15"){
      ndc = "00002143480";
    }

    const data = {
      quarter: quarter,
      year:year,
      companyId: e[0],
      ndc:ndc
    };

    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-qir-data-for-update`;
    const res = axios.post(url,data)
    .then((response)=>{
      console.log(response);
      if(response.data === "No drug found for this company."){
        alert("No data for this drug during this quarter!");
      }else{
        var start_with = 0;
        if(response.data.startWith !== null){
          start_with = response.data.startWith;
        }
        document.getElementById('qir-start-with-old').value = start_with;
        document.getElementById('old-qir-previous').value = response.data.onHand;
        document.getElementById('old-qir-ordered').value = response.data.ordered;
        document.getElementById('old-qir-filled-not-picked').value = response.data.filledNotPicked;
        document.getElementById('old-qir-dispensed').value = response.data.dispensed;
        document.getElementById('old-qir-expired').value = response.data.expired;
        document.getElementById('old-qir-total').value = response.data.total;
        document.getElementById('old-qir-match').value = response.data.match;
        document.getElementById('qir-old-exp').value = response.data.explanation;
      }


    });

  }

  handleClick = () => {
    var e = document.getElementById('site-select').value;
    e = e.split(" : ");

    var tempName = '';
    var tempArray = [];
    var name = e[1];
    if(name.length > 60){
      tempArray = name.split(" ");

      for(var j = 0;j<tempArray.length;j++){
        tempName += tempArray[j] + " ";
        if(tempName.length > 60){
          break;
        }else{
          name = tempName;
        }
      }
    }

    const data =  {
      drug:document.getElementById('qir-select').value,
      Quarter:document.getElementById('qir-update-quarter-input').value,
      Year:document.getElementById('qir-update-year-input').value,
      updatePrevious:document.getElementById('qir-previous').value,
      updateOrdered:document.getElementById('qir-ordered').value,
      updateFilledNotPicked:document.getElementById('qir-filled-not-picked').value,
      updateDispensed:document.getElementById('qir-dispensed').value,
      updateExpired:document.getElementById('qir-expired').value,
      updateTotal:document.getElementById('qir-total').value,
      updateMatch:document.getElementById('qir-match').value,
      updateExplanation:document.getElementById('qir-exp').value,
      updateStartWith:document.getElementById('qir-start-with').value,
      siteId:e[2],
      companyId:e[0],
      site:name,
      updateOldPrevious:document.getElementById('old-qir-previous').value,
      updateOldOrdered:document.getElementById('old-qir-ordered').value,
      updateOldFilledNotPicked:document.getElementById('old-qir-filled-not-picked').value,
      updateOldDispensed:document.getElementById('old-qir-dispensed').value,
      updateOldExpired:document.getElementById('old-qir-expired').value,
      updateOldTotal:document.getElementById('old-qir-total').value,
      updateOldMatch:document.getElementById('old-qir-match').value,
      updateOldExplanation:document.getElementById('qir-old-exp').value
    };
    console.log(data);
    const url = `https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/qir-data-to-database`;
    const res = axios.post(url,data)
    .then((response)=>{
      if(response.data === "Success!"){
        var ordered = document.getElementById('qir-ordered');
        var old_ordered = document.getElementById('old-qir-ordered');
        var dispensed = document.getElementById('qir-dispensed');
        var old_dispensed = document.getElementById('old-qir-dispensed');
        var previous = document.getElementById('qir-previous');
        var old_previous = document.getElementById('old-qir-previous');
        var old_not_picked = document.getElementById('old-qir-filled-not-picked');
        var picked = document.getElementById('qir-filled-not-picked');
        var year = document.getElementById('qir-update-year-input');
        var quarter = document.getElementById('qir-update-quarter-input');
        var expired = document.getElementById('qir-expired');
        var old_expired = document.getElementById('old-qir-expired');
        var total = document.getElementById('qir-total');
        var old_total = document.getElementById('old-qir-total');
        var match = document.getElementById('qir-match');
        var old_match = document.getElementById('old-qir-match');
        var explanation = document.getElementById('qir-exp');
        var old_explanation = document.getElementById('qir-old-exp');
        var next = document.getElementById('qir-start-with');
        var old_next = document.getElementById('qir-start-with-old');

        ordered.value = null;
        old_ordered.value = null;
        dispensed.value = null;
        old_dispensed.value = null;
        previous.value = null;
        old_previous.value = null;
        old_not_picked .value = null;
        picked.value = null;
        //year.value = 2nullnullnull;
        //quarter.value = null;
        expired.value = null;
        old_expired.value = null;
        total.value = null;
        old_total.value = null;
        match.value = "Yes";
        old_match.value = "";
        explanation.value = "";
        old_explanation.value = "";
        next.value = null;
        old_next.value = null;
        alert('Insulin Reconciliation Updated! View on the View Insulin Reconciliation Page or refresh the data on this page!');
      }else{
        alert("Whoops! Error occured, please contact IT team!");
      }

    });
  }

  clearNDC = () => {

    var ordered = document.getElementById('qir-ordered');
    var old_ordered = document.getElementById('old-qir-ordered');
    var dispensed = document.getElementById('qir-dispensed');
    var old_dispensed = document.getElementById('old-qir-dispensed');
    var previous = document.getElementById('qir-previous');
    var old_previous = document.getElementById('old-qir-previous');
    var old_not_picked = document.getElementById('old-qir-filled-not-picked');
    var picked = document.getElementById('qir-filled-not-picked');
    var year = document.getElementById('qir-update-year-input');
    var quarter = document.getElementById('qir-update-quarter-input');
    var expired = document.getElementById('qir-expired');
    var old_expired = document.getElementById('old-qir-expired');
    var total = document.getElementById('qir-total');
    var old_total = document.getElementById('old-qir-total');
    var match = document.getElementById('qir-match');
    var old_match = document.getElementById('old-qir-match');
    var explanation = document.getElementById('qir-exp');
    var old_explanation = document.getElementById('qir-old-exp');
    var next = document.getElementById('qir-start-with');
    var old_next = document.getElementById('qir-start-with-old');

    ordered.value = 0;
    old_ordered.value = 0;
    dispensed.value = 0;
    old_dispensed.value = 0;
    previous.value = 0;
    old_previous.value = 0;
    old_not_picked .value = 0;
    picked.value = 0;
    //year.value = 2000;
    //quarter.value = 0;
    expired.value = 0;
    old_expired.value = 0;
    total.value = 0;
    old_total.value = 0;
    match.value = "Yes";
    old_match.value = "";
    explanation.value = "";
    old_explanation.value = "";
    next.value = 0;
    old_next.value = 0;

  }

  componentDidMount() {
    fetch("https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/production/get-sites-shipping-manifest")
      .then(res => {
        return res.text();
      })
      .then(
        (result) => {
          console.log(result)
          var load = document.getElementById('nonbreak');
          load.insertAdjacentHTML('afterend','<br id="newbreak"></br>');
          load.insertAdjacentHTML('afterend',result);
          if(document.getElementById('loading-sites')){
            document.getElementById('loading-sites').remove();
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render(){
    return(
    <div class="update-insulin-reconciliation">
        <p id='loading-sites'>Loading sites...</p>
        <center>
        <label for="qir-label" id="qir-label" style={{margin:'3px',fontSize:'24px',color:'#be1f41',textAlign:'center',width:'600px'}}>Quarterly Insulin Reconciliation Update</label><br id="nonbreak"></br>
        <select name="qir-select" id="qir-select" style={{width: '35%',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'600px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}} onChange={this.clearNDC}>
          <option value="Humulin7030">Humulin 70/30 Suspension for Injection</option>
          <option value="HumulinN">Humulin N 100unit/ml Suspension for Injection</option>
          <option value="HumulinR">Humulin R 100units/mL Solution for Injection</option>
          <option value="Humalog">Humalog 100unit/ml Solution for Injection</option>
          <option value="Basaglar">Basaglar KwikPen 100units/mL Pre-Filled Pen Solution for Injection</option>
          <option value="Humalog7525">Humalog KwikPen Mix 75/25 Pre-Filled Pen Suspension for Injection</option>
          <option value="HumalogPre">Humalog KwikPen 100unit/ml Pre-Filled Pen Solution for Injection	</option>
          <option value="Trulicity75">Trulicity 0.75mg/0.5mL Solution for Injection</option>
          <option value="Trulicity15">Trulicity 1.5mg/0.5mL Solution for Injection</option>
        </select><br></br>
        <label for="qir-update-quarter-input" id="qir-update-quarterLabel" style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'5%'}}>Quarter</label>
        <input type="number" name="qir-update-quarter" id="qir-update-quarter-input" min="1" max="4" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <label for="qir-update-year-input" id="qir-update-yearLabel"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'5%'}}>Year</label>
        <input type="number" name="qir-update-year" id="qir-update-year-input"  min="2000" max="3000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <input type="submit" name="refresh-qir" id="qir-refresh-button" value="REFRESH" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.refreshClick}></input><br></br>


        <label for="qir-previous-label" id="qir-previous-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old # of Vials or Individual Pens on Last Day of Previous Quarter</label>
        <input type="number" name="qir-previous" disabled id="old-qir-previous"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-previous-label" id="qir-previous-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}># of Vials or Individual Pens on Last Day of Previous Quarter</label>
        <input type="number" name="qir-previous" id="qir-previous"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <label for="qir-ordered-label" id="qir-ordered-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old # of Vials or Individual Pens Ordered this Quarter</label>
        <input type="number" name="qir-ordered" disabled id="old-qir-ordered"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-ordered-label" id="qir-ordered-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}># of Vials or Individual Pens Ordered this Quarter</label>
        <input type="number" name="qir-ordered" id="qir-ordered"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <label for="qir-dispensed-label" id="qir-dispensed-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old # of Vials or Individual Pens Dispensed to Patients this Quarter</label>
        <input type="number" name="qir-dispensed" disabled id="old-qir-dispensed"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-dispensed-label" id="qir-dispensed-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}># of Vials or Individual Pens Dispensed to Patients this Quarter</label>
        <input type="number" name="qir-dispensed" id="qir-dispensed"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <label for="qir-filled-not-picked-label" id="qir-filled-not-picked-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old # of Vials or Individual Pens Filled but not Picked up this Quarter</label>
        <input type="number" name="qir-filled-not-picked" disabled id="old-qir-filled-not-picked"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-filled-not-picked-label" id="qir-filled-not-picked-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}># of Vials or Individual Pens Filled but not Picked up this Quarter</label>
        <input type="number" name="qir-filled-not-picked" id="qir-filled-not-picked"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <label for="qir-expired-label" id="qir-expired-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old # of Vials or Individual Pens Expired/Damaged During this Quarter</label>
        <input type="number" name="qir-expired" disabled id="old-qir-expired"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-expired-label" id="qir-expired-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}># of Vials or Individual Pens Expired/Damaged During this Quarter</label>
        <input type="number" name="qir-expired" id="qir-expired"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <label for="qir-total-label" id="qir-total-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old # of Total Vials or Individual Pens on Hand</label>
        <input type="number" name="qir-total" disabled id="old-qir-total"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-total-label" id="qir-total-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}># of Total Vials or Individual Pens on Hand</label>
        <input type="number" name="qir-total" id="qir-total"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>

        <label for="qir-match-label" id="qir-match-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old - Does the # of Total Vials or Individual Pens on Hand match your current physical inventory?</label>
        <input type="text" name="qir-match" disabled id="old-qir-match" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-match-label" id="qir-match-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Does the # of Total Vials or Individual Pens on Hand match your current physical inventory?</label>
        <select id="qir-match" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}><option value="Yes">Yes</option><option value="No">No</option></select><br></br>

        <label for="qir-exp-label" id="qir-exp-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old - If the current physical inventory does not match, please explain the efforts made to reconcile.</label>
        <textarea name="qir-exp" id="qir-old-exp" disabled style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></textarea>

        <label for="qir-exp-label" id="qir-exp-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>If the current physical inventory does not match, please explain the efforts made to reconcile.</label>
        <textarea name="qir-exp" id="qir-exp" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></textarea><br></br>

        <label for="qir-correct-label" id="qir-correct-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>Old - If NO, list correct # of Vials or Pens to start next quarter with".</label>
        <input type="number" name="qir-start-with-old" disabled id="qir-start-with-old"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'lightgray',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input>

        <label for="qir-correct-label" id="qir-correct-label"  style={{margin:'3px',fontSize:'16px',color:'#be1f41',width:'30%'}}>If NO, list correct # of Vials or Pens to start next quarter with".</label>
        <input type="number" name="qir-start-with" id="qir-start-with"  min="0" max="100000" style={{width: '12%', borderWidth: '1px',height: '2rem', color:'#be1f41',margin:'10px',minWidth:'70px',backgroundColor:'white',fontSize:'15px',paddingLeft:'3px',paddingRight:'3px'}}></input><br></br>


        <input type="submit" name="submit-qir" id="qir-submit-button" value="UPDATE" style={{width: '10%',height: '2rem', backgroundColor:'#be1f41',margin:'10px',minWidth:'70px',border:'none',color:'white',fontSize:'15px',fontWeight:'bold',paddingLeft:'30px',paddingRight:'30px'}} onClick={this.handleClick}></input><br></br>
        </center>
    </div>
  );
  }
}


class QuarterlyNumberReviewPage extends Component{

  render(){
    return (
      <center>
      <div className='quarterly-number-review'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="quarterly_number_review"/>
      </div>
      </center>
    );
  }
}

class DestructionOfDrugsPage extends Component{

  render(){
    return (
      <center>
      <div className='destruction-of-drugs'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="destruction_of_drugs"/>
      </div>
      </center>
    );
  }
}

class CharitableFormularyPage extends Component{

  render(){
    return (
      <center>
      <div className='charitable-formulary'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="charitable_formulary"/>
      </div>
      </center>
    );
  }
}

class PharmacyServicesPage extends Component{

  render(){
    return (
      <center>
      <div className='pharmacy-services'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="pharmacy_services"/><br></br>
      </div>
      </center>
    );
  }
}

class MonthlyWacAccountingPage extends Component{

  render(){
    return (
      <center>
      <div className='monthly-wac-accounting'>
      <div id="dashboardContainer"></div>
      <GetEmbedUrl page="monthly-wac-accounting"/><br></br>
      </div>
      </center>
    );
  }
}

class StudentProjectPage extends Component{

  render(){
    return (
      <center>
      <div className='student-project-form'>
      <div></div>
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfPTi01Pqfd0QiolnhZtzquvR9X2sCgDnenAMdHdNwvcfGXkQ/viewform?usp=pp_url" title="Student Project Request" width="1000px" height="1000px"></iframe>
      </div>
      </center>
    );
  }
}

class GettingToKnowPage extends Component{

  render(){

    const gridContainer = {
        display: "grid",
        gridTemplateColumns: "auto auto auto auto",
        gridGap: "10px",
        padding: "10px",
        border: "1px solid black",
        gridTemplateColumns: "repeat(3, 1fr)",
        textAlign: "center",
        fontSize: "30px",
    };
    /*
      To add another thumbnail, go to the google drive with the getting to know you profiles, click the 3 dots in the top right,
      click share, click copy link, go to the link, click the 3 dots again, click embed item, copy and paste below

      <div>
        PASTE HERE
      </div>

    */
    const pictureStyle = {
      height: '400px',
      width:'500px',
    };

    return (
      <center>
      <div className='getting-to-know'>
        <div style={gridContainer}>



          <div>
            <img src={alhassanGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={angelaGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={anitaGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={hillaryGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={joshMitchellGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={justinHolderGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={justinWardGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={kataGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={maeganGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={maryLankfordGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={maryOlsonGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={mattBlountGTKY} style={pictureStyle}></img>
          </div>

          <div>
            <img src={michelleWilsonGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={millerGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={sharonGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={shannonGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={scottGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={murtadaMahmoodGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={taraGTKY} style={pictureStyle}></img>
          </div>
          <div>
            <img src={teriGTKY} style={pictureStyle}></img>
          </div>


        </div>
      </div>
      </center>
    );
  }
}

const Main = () => (
  <Routes>
    <Route exact path='/' element={<Home/>}/>
    <Route exact path='/about' element={<About/>}/>
    <Route exact path='/contact' element={<Contact/>}/>
    <Route exact path='/accountmanagement' element={<AccountManagementPage/>}/>
    <Route exact path='/distribution' element={<DistributionPage/>}/>
    <Route exact path='/fundmanagement' element={<FundManagementPage/>}/>
    <Route exact path='/networkexpansion' element={<NetworkExpansionPage/>}/>
    <Route exact path='/supplychain' element={<SupplyChainPage/>}/>
    <Route exact path='/therapeutics' element={<TherapeuticsPage/>}/>
    <Route exact path='/leadership' element={<LeadershipPage/>}/>
    <Route exact path='/infotech' element={<InformationTechPage/>}/>
    <Route exact path='/marketing' element={<MarketingPage/>}/>
    <Route exact path='/product-creation' element={<ProductCreationPage/>}/>
    <Route exact path='/pamsdashboard' element={<PamsDashboardPage/>}/>
    <Route exact path='/supply-chain-dashboard' element={<ScottsDashboardPage/>}/>
    <Route exact path='/donorreport' element={<DonorReportPage/>}/>
    <Route exact path='/orderingtool' element={<OrderingToolPage/>}/>
    <Route exact path='/donor-receipt' element={<DonorReceiptPage/>}/>
    <Route exact path='/ne-overview-dashboard' element={<NEOverviewDashboardPage/>}/>
    <Route exact path='/am-dashboard' element={<AmDashboardPage/>}/>
    <Route exact path='/insulin-tracker' element={<InsulinTrackerPage/>}/>
    <Route exact path='/it-analytics' element={<ItDashboardPage/>}/>
    <Route exact path='/usage-tracking' element={<UsageDashboardPage/>}/>
    <Route exact path='/irregular-orders' element={<IrregularOrdersPage/>}/>
    <Route exact path='/ehope-reports' element={<EhopeReportPage/>}/>
    <Route exact path='/shipping-manifest' element={<ShippingManifestPage/>}/>
    <Route exact path='/dohdashboard' element={<DohDashboardPage/>}/>
    <Route exact path='/destruction-of-drugs' element={<DestructionOfDrugsPage/>}/>
    <Route exact path='/getting-to-know' element={<GettingToKnowPage/>}/>
    <Route exact path='/charitable-formulary' element={<CharitableFormularyPage/>}/>
    <Route exact path='/pharmacy-services' element={<PharmacyServicesPage/>}/>
    <Route exact path='/receiving-distributing-p1' element={<ReceivingDistP1Page/>}/>
    <Route exact path='/quarterly-number-review' element={<QuarterlyNumberReviewPage/>}/>
    <Route exact path='/quarterly-numbers' element={<QuarterlyNumbersPage/>}/>
    <Route exact path='/view-insulin-reconciliation' element={<ViewInsulinReconciliationPage/>}/>
    <Route exact path='/update-insulin-reconciliation' element={<InsulinReconciliationUpdatePage/>}/>
    <Route exact path='/target-list' element={<IQVIAtargetListPage/>}/>
    <Route exact path='/it-request' element={<ITrequestPage/>}/>
    <Route exact path='/product-data' element={<ProductDataPage/>}/>
    <Route exact path='/student-project-form' element={<StudentProjectPage/>}/>
    <Route exact path='/weighted-scores' element={<WeightedScoresPage/>}/>
    <Route exact path='/last-stocked-last-shipped' element={<LastStockedShippedPage/>}/>
    <Route exact path='/optum-tool' element={<OptumToolDashboard/>}/>
    <Route exact path='/disease-state' element={<DiseaseStatePage/>}/>
    <Route exact path='/recalled-products' element={<RecalledProductsPage/>}/>
    <Route exact path='/marketing-dashboard' element={<MarketingDashboardPage/>}/>
    <Route exact path='/cold-chain-product' element={<ColdChainProductDashboard/>}/>
    <Route exact path='/prasco-report' element={<PrascoReportDashboard/>}/>
    <Route exact path='/allocation' element={<AllocationPage/>}/>
    <Route exact path='/search-by-serial' element={<SearchByPOPage/>}/>
    <Route exact path='/targeted-report' element={<SupplyChainTargetedReportPage/>}/>
    <Route exact path='/target-list-availability' element={<TargetListAvailabilityPage/>}/>
    <Route exact path='/dc-orders' element={<DCOrderPage/>}/>
    <Route exact path='/monthly-wac-accounting' element={<MonthlyWacAccountingPage/>}/>
    <Route exact path='/yearly-donor-receipt' element={<YearlyDonorReceiptCsvPage/>}/>
    <Route exacf path="/address-shortener" element={<AddressShortenerPage />} />
  </Routes>
);

export class GetEmbedUrl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };
  }

  componentDidMount() {
    fetch("https://ut5thfupc4.execute-api.us-east-1.amazonaws.com/sandbox/internal-reporting-embed?page=" + this.props.page)
      .then(res => res.json())
      .then(
        (result) => {
          embeddingContext.embedDashboard({
              url: result.EmbedUrl,
              container: document.getElementById('dashboardContainer'),
              headers: {
                'Access-Control-Allow-Origin': 'https://dispensary-of-hope-sandbox.mybigcommerce.com/',
                "Access-Control-Allow-Methods": "GET,OPTIONS,POST",
                "Access-Control-Allow-Headers": "*"
              },
              height: '1000px',
              loadingHeight: '320px',
              printEnabled: true,
            });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    }else {
      console.log(items);
      return (
        <Iframe url={items}
        width={"1200px"}
        height={"750px"}
        id="myId"
        frameBorder="0"
        className="myClassname"
        display="initial"
        position="relative"/>
      );
    }
  }
}

export default Main;
